import { createSelector } from "reselect";

import { getProductIsFefoEnabled } from "common/utils/product/getProductIsFefoEnabled";
import { getSelectedProducts } from "./getSelectedProducts";

export const selectStorageProductsWithFefoEnabled = createSelector(getSelectedProducts, (selectedProducts) =>
  selectedProducts.filter(getProductIsFefoEnabled)
);
